import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { selectSize, selectThemeSize, iconTheme } from "../../../data/data";

@Component({
  selector: 'app-sucu05-button0010004',
  templateUrl: './sucu05-button0010004.component.html',
  styles: [
    `
  `
  ]
})
export class Sucu05Button0010004Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() sets = {
    blockId: "",
    blockName: "批量删除按钮",
    layoutId: "",
    blockType: 'formButton',
    blockChildType: '',
    versionCode: 1,
    styles: {
      nzText: "批量删除",
      nzType: "default",
      nzSize: "default",
      nzBgColor: "",
      nzConfirm: {
        nzShow: true,
        nzTitle: "提示",
        nzContent: "确定要删除吗？"
      },
      nzIcon: {
        nzIconType: '',
        nzIconTheme: '',
        nzIconColor: '',
      },
    },
    datas: {
      nzDataSource: "",
    }
  };


  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzDataSource', }
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                }
              },
              {

                name: 'select',
                inputs: {
                  nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                outputs: {
                  ngModelChange: (event) => {


                    if (event == 'twotone') {

                      this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                    } else {
                      this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                    }


                    this.setService.onReLoadbBlock(this.layoutid);

                  }
                }
              },
              {
                name: 'input',
                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
              },
              {
                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                inputs: {
                  nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                }
              },
              {
                name: 'color',
                inputs: {
                  nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              { name: 'nzConfirm' }
            ]
          },
        ]
      }
    ]

  }




  constructor(
    public setService: SetService,
  ) { }
  ngOnInit() {
    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }
       
      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
  }
  onClick(): void {
    const datas = {
      "isShow": this.sets.styles.nzConfirm.nzShow,
      "title": this.sets.styles.nzConfirm.nzTitle,
      "content": this.sets.styles.nzConfirm.nzContent
    }
    this.setService.sendEvent(this.sets.datas.nzDataSource, "deleteMore", datas)
  }

}



